var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"base-collection-container",class:{'base-collection-container__border':_vm.border}},[_c('el-main',[_c('div',{staticClass:"base-collection",class:{'base-collection__border':_vm.border},style:({
                '--columns':_vm.columns,
                '--collectionSpace':_vm.space
               })},_vm._l((_vm.dataSource),function(object,index){return _c('div',{key:index,staticClass:"base-collection__cell"},[_vm._t("cell",function(){return [_vm._v(" "+_vm._s(index)+" ")]},{"object":object,"index":index})],2)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }